module.exports = __webpack_public_path__ + "doll.jpg?b0f5ceedf2385c3d7b119208781161b6";